<template>
    <div class="row dashboard-page" id="dashboardPage">
        <div class="col-md-1"></div>
        <div class="col-md-10">
            <div class="row dashboard-border">
                <div class="col-lg-4 col-7 col-md-6" v-perm="'permTest'">
                    <img src="../assets/icons/dashboardIcon.png" class="mx-2" width="35">
                    <span>Corendon Applications</span>
                    <span v-permcheck="'users.W'" v-perm="'heded'">Okey Permission Test</span>&nbsp;
                    <span v-permcheck="'users231'">No Permission Test ></span>
                </div>
                <div v-rolecheck="'ADMIN'" class="col-lg-8 col-5 text-end col-md-6" style="align-self: center">
                    <router-link :to="{name:'Projects'}">
                        <span>Edit Projects</span>
                    </router-link>
                </div>
            </div>
            <div class="row gx-5 gy-3 mt-1 card-text-style dashboard-page-content">
                <div v-for="project in filteredProjectOfUsers" :key="project.id" class="col-md-6 col-12 p-0 col-lg-3"
                     @click="project.fStatus == 1 ? goToWebSite(project.mainRoute,project.code,project.usesSingleSignOn) : ''"
                     target="_blank" style="cursor: pointer" :style="projectHidden(project.code)">
                    <div v-if="project.code!== 'CSL'" :style="projectColor(project.fStatus)" style="background: #FFFFFF;box-shadow:0px 3px 10px #ced4da;border-radius: 8px;
                   margin-right: 15px;" class="card-hover">
                      <div  class="d-flex justify-content-center" style="padding: 40px 30px" v-if="isProjectIcon(project.code)">
                        <img :src="require(`../assets/projectIcon/${project.code}.png`)"
                             width="auto" height="55" :alt="require('../assets/icons/corendon.png')">
                      </div>
                      <span v-else>
                        {{project.name}}
                      </span>
                    </div>
                  <div v-else :style="projectColor(project.fStatus)" style="background: #FFFFFF;box-shadow:0px 3px 10px #ced4da;border-radius: 8px;
                   margin-right: 15px;" class="card-hover">
                    <div  class="d-flex justify-content-center" style="padding: 35px 30px" v-if="isProjectIcon(project.code)">
                      <img :src="require(`../assets/projectIcon/${project.code}.png`)"
                           width="auto" height="65" :alt="require('../assets/icons/corendon.png')">
                    </div>
                    <span v-else>
                  {{project.name}}
                </span>
                  </div>
                </div>

            </div>
        </div>
        <div class="col-md-1"></div>
    </div>
</template>
<script>
    import {mapActions, mapState} from "vuex";

    export default {

        name: "DashboardPage",
        data() {
            return {}
        },
        methods: {
            ...mapActions('projects', ['getProjects', 'getProjectOfUser']),

            projectColor(stat) {
                if (stat == 0) {
                    return {
                        'background-color': '#2921211a',
                        'cursor': 'default',
                    }
                }
                if (stat == 1) {
                    return {
                        'background-color': '#ffffff'
                    }
                } else {
                    return {
                        'background-color': '#ffda3c33'
                    }
                }
            },
            projectHidden(code) {
              if (code == 'AUT') {
                return {
                  'display': 'none'
                }
              }
            },
            async TryGoToProjectDetail(projectId, projectCode) {
                this.$router.push({
                    name: 'DashboardDetail',
                    params: {projectId: projectId, code: projectCode}
                });
            },
            async goToRolePerm(value, name, code) {
                this.$router.push({
                    name: 'ProjectDetails',
                    params: {selectedProjectId: parseInt(value), selectedProjectName: name, selectedProjectCode: code}
                });
            },

            // async func(event) {
            //     // const element = event.currentTarget;
            //     // const test = element.getAttribute('data-deneme')
            //     // console.log(test);
            // },
            goToWebSite(mainRoute, code, useSSO) {
              if(code ==='TUR'){
                    this.$router.push({
                        name:'TursysLogin'
                    })
                }
                // else if (code === 'FLY') {
                //     this.$router.push({
                //         name: 'FlycoLogin'
                //     })
                // }
                //
                //
                // else if (code === 'CMS') {
                //     this.$router.push({
                //         name: 'CmsLogin'
                //     })
                // }
                else if (!useSSO) {
                    window.open(mainRoute.toString(), '_blank');
                }

                else {
                    let route = mainRoute + this.user.email + "," + localStorage.getItem("refresh_token");
                    window.open(route.toString(), '_blank');
                }
            }
            ,
            isProjectIcon(value) {
                let fileList = []
                const illustrations = require.context(
                    '@/assets/projectIcon',
                    true
                )

                fileList = illustrations.keys()
               // console.log(fileList)
                let searcText = './' + value + '.png'
                if (fileList.includes(searcText)) {
                    return true;
                } else {
                    return false;
                }
            }

        },
        computed: {
            ...mapState('projects', ['projects', 'projectsOfUser']),
            ...mapState("auth", ["user", "refreshToken"]),

          filteredProjectOfUsers: function () {
            return this.projectsOfUser.filter((post) => {
              return post.code != 'AUT';
            }).sort((a, b) => a.priority - b.priority);
          },


        },
        beforeMount() {
        },

        created() {
            this.getProjectOfUser();
            setInterval(() => {
            }, 60000);
        }
    }

</script>

<style scoped>

    .dashboard-page {
        /*background-image: url("../assets/images/CAI.jpg");*/
        /*position: absolute;*/
        left: 0px;
        /*width: 100%;*/
        height: 87%;
        background-size: cover !important;
        background-position: 50% 50% !important;


    }

    .card-hover:hover {
        box-shadow: 0px 3px 10px #8d8d95 !important;
    }

    .dropbtn {
        color: white;
        padding: 16px;
        font-size: 16px;
        border: none;
    }

    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #f1f1f1;
        min-width: 160px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        z-index: 1;
    }

    .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    .dropdown-content a:hover {
        background-color: #ddd;
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }

    .dropdown-item:active {
        background-color: #eaedf2;
        color: #383838;
    }

    .run-icon:hover {
        cursor: pointer;
    }

    .perm-style {
        font-weight: 550;
        font-size: 15px;
        cursor: pointer;
        color: #5670cc;
        font-family: Helvetica, Arial;
        text-decoration: unset;
    }

    .card-text-style span {
        font-family: Helvetica, Arial;
        color: #383838;
    }

    a {
        text-decoration: unset !important;
    }

</style>
